/**
 * Study Mode Layout component
 * Main layout for Study Mode app pages
 */

import {ReactNode} from 'react';
import {StudySidebar} from './StudySidebar';
import {StudyHeader} from './StudyHeader';
import {ToastContainer} from '../ui/Toast';

interface StudyLayoutProps {
  children: ReactNode;
}

export function StudyLayout({children}: StudyLayoutProps) {
  return (
    <div className="h-screen bg-background dark:bg-[#1E1E1E] flex flex-col overflow-hidden">
      <StudyHeader />
      <div className="flex flex-1 overflow-hidden min-h-0">
        <StudySidebar />
        <main className="flex-1 overflow-hidden flex flex-col min-h-0">
          {children}
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}

